import { render, staticRenderFns } from "./contact_service.vue?vue&type=template&id=2abb8c02&scoped=true&"
import script from "./contact_service.vue?vue&type=script&lang=js&"
export * from "./contact_service.vue?vue&type=script&lang=js&"
import style0 from "./contact_service.vue?vue&type=style&index=0&id=2abb8c02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb8c02",
  null
  
)

export default component.exports